export class SignatoryTypeRoleFilter {
    active?: boolean;
    inactive?: boolean;
    name?: string;
    skip: number;
    take: number;
}
